const PARENT_ORIGIN = process.env.REACT_APP_THUNAI_DASHBOARD_URL ||
  window?.env?.THUNAI_DASHBOARD_URL;
console.log("procces.env", process.env.REACT_APP_THUNAI_DASHBOARD_URL);
console.log("window.env", window?.env?.THUNAI_DASHBOARD_URL);

console.log("parent", PARENT_ORIGIN);

function isTrustedParent(event) {
  return (
    event.origin === PARENT_ORIGIN &&
    event.source === window.parent
  );
}

export const initAuthFromParent = () => {
  return new Promise((resolve) => {
    let settled = false;

    const cleanup = () => {
      window.removeEventListener("message", onMessage);
    };

    const onMessage = (event) => {
      if (!isTrustedParent(event)) return;

      const msg = event.data;

      if (!msg || msg.type !== "AUTH_CONTEXT") return;

      console.log("mesa", msg);

      settled = true;
      cleanup();

      const payload = msg.payload;

      if (!payload?.userInfo) {
        resolve(null);
        return;
      }

      // Keep in memory if possible (best)
      resolve(payload);

      // Store in localStorage
      localStorage.setItem(
        "user_info",payload.userInfo
      );
    };

    window.addEventListener("message", onMessage);

    console.log("parent origin", PARENT_ORIGIN);

    // Ask parent for auth context
    window.parent.postMessage(
      { type: "REQUEST_AUTH_CONTEXT" },
      PARENT_ORIGIN
    );

    // Optional timeout so app does not hang forever
    setTimeout(() => {
      if (settled) return;

      cleanup();
      resolve(null);
    }, 5000);
  });
};